<template>
  <v-simple-table>
    <thead>
      <tr>
        <th>No</th>
        <th>Name</th>
        <th>Age</th>

        <th>Type</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="presumptiveData.case_found_at">
        <td>1</td>
        <td>{{ presumptiveData.name }}</td>
        <td>{{ presumptiveData.dob }}</td>
        <td>Patient</td>
        <td>
          <v-btn
            @click="goToFollowUpSaveForm"
            icon
            color="orange darken-1"
            class="mr-2 white--text"
            depressed
          >
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </td>
      </tr>
      <tr
        v-else
        v-for="(item, index) in presumptiveData"
        v-bind:key="item.id"
        v-show="!item.reg_unique_code && checkIfDuplicate(item)"
      >
        <td>{{ index + 1 }}</td>
        <td>
          {{ item.name }}
        </td>
        <td>
          {{ item.age }}
        </td>

        <td>
          <span v-if="item.confirm == 0">
            <span
              v-if="item.relationship == 1 && item.referral_from_id == null"
            >
              Family Member
            </span>
            <span
              v-else-if="
                item.relationship == 1 && item.referral_from_id != null" >
              Household
            </span>
            <span v-else-if="item.case_found_at == 5">Follow Up (Refer)</span>
            <span v-else-if="item.existing_presumptive_id">Refer</span>
            <span v-else> Close Contact </span>
            <!-- <span v-else> Non-household </span> -->
          </span>
          <span v-else>Presumptive</span>
        </td>
        <td>
          <v-btn v-if="item.existing_presumptive!=1"
            @click="addOtherContact(item)"
            icon 
            color="orange darken-1"
            class="mr-2 white--text"
            depressed 
          ><v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn v-else
            @click="goToForm(item)"
            icon
            color="orange darken-1"
            class="mr-2 white--text"
            depressed
          >
            <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
        <v-btn
          @click="$router.push(`/presumptive-edit/${item.id}`)"
            icon
            color="orange darken-1"
            class="mr-2 white--text"
            depressed
          >
          <v-icon>mdi-apps-box</v-icon>
          </v-btn>
        
          <v-btn
            @click="openConfrimBox(item)"
            icon
            color="red lighten-1"
            class="white--text"
            depressed
          >
            <v-icon> mdi-delete-outline </v-icon>
          </v-btn>
          <confirm-box
            :dialog="dialog"
            @confirmed="deletPresumptive"
            @cancel="cancel"
          />
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";

export default {
  components: {
    ConfirmBox,
  },
  computed: {
    ...mapState("Presumptive", ["presumptiveData"]),
  },
  data: () => ({
    item: {},
    dialog: false,
  }),
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deletPresumptive() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("Presumptive/deletePresumptive", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    checkIfDuplicate(item) {
      var isShow = true;
      if (item.existing_presumptive == 2 && item.confirm == 1) {
        this.presumptiveData.forEach((element) => {
          if (element.id == item.existing_presumptive_id) {
            isShow = false;
          }
        });
      }
      return isShow;
    },
    goToFollowUpSaveForm() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({
            type: "Followup",
            index_case_no: this.presumptiveData.mdrtb_reg_no,
            index_case_year: this.presumptiveData.mdrtb_reg_year,
            name: this.presumptiveData.name,
            sex: this.presumptiveData.sex,
            patient_id: this.presumptiveData.id,
          }),
        },
      });
    },
    goToForm(item) {
      if (item.confirm == 0) {
        if (item.relationship == 1) {
          if (item.referral_from_id == null) {
            this.$router.push({
              name: "create-presumptive",
              params: {
                township_id: this.$route.params.township_id,
                type: JSON.stringify({
                  type: "Family",
                  index_case_no: item.index_case_no,
                  index_case_year: item.index_case_year,
                  family_member_id: item.id,
                }),
              },
            });
          } else {
            this.$router.push(`/save-as-presumptive/${item.id}/REFERRAL`);
          }
        } else if (item.existing_presumptive == 2) {
          this.$router.push(`/save-as-presumptive/${item.id}/Existing`);
        } else if (item.relationship == 2 || item.case_found_at == 5) {
          this.$router.push(`/save-as-presumptive/${item.id}/REFERRAL`);
        }
      } else {
       
        let id =
          item.existing_presumptive == 2
            ? item.existing_presumptive_id
            : item.id;
        this.$router.push(`/presumptive-detail/${id}`);
      }
    },
    addOtherContact(item) {
      console.log('addOtherContact');
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({
            type: "close-contact",
            name:item.name,
            age:item.age,
            sex:item.sex,
            index_case_no: item.index_case_no,
            index_case_year: item.index_case_year,
            id:convertNumber,
          }),
        },
      });
    },
    
  },
};
</script>

<style></style>
